import { render, staticRenderFns } from "./AttachmentImage.vue?vue&type=template&id=2f1b00e1"
import script from "./AttachmentImage.vue?vue&type=script&lang=js"
export * from "./AttachmentImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports